var $ = require('jquery');

(function(Contact, undefined) {

    Contact.ContactService = (function setupContactService(jquery) {

        var service = {

            postContact: function postContact(contactForm, token) {
                return jquery.ajax({
                    url: '/Contact/Contact',
                    method: 'POST',
                    data: {
                        __RequestVerificationToken: token,
                        contact: contactForm
                    }
                });
            },
            postBrochureRequest: function postBrochureRequest(contactForm, token) {
                return jquery.ajax({
                    url: '/Contact/Brochure',
                    method: 'POST',
                    data: {
                        __RequestVerificationToken: token,
                        contact: contactForm
                    }
                });
            },
            getCountries: function getCountries() {
                return jquery.ajax({
                    url: '/FormControls/GetCountries',
                    method: 'GET'
                });
            },

            getStates: function getStates() {
                return jquery.ajax({
                    url: '/FormControls/GetStates',
                    method: 'GET'
                });
            },

            getCities: function getCities(stateId) {
                return jquery.ajax({
                    url: '/FormControls/GetCities/?stateId=' + stateId,
                    method: 'GET'
                });
            },

            getZipCodes: function getZipCodes(stateId, city) {
                return jquery.ajax({
                    url: '/FormControls/GetZipCodes/?stateId=' + stateId + '&city=' + city,
                    method: 'GET'
                });
            }

        };

        return service;

    })($);

}(window.Contact.Services = window.Contact.Services || {}));